import appConfig from 'config/config';
import useService from './axios-config';
import { KYC, SESSION_STORAGE, COMMON } from '../constants';
import { findParamFromUrl, getFromSessionStorage } from 'common/utils/app.utils';

const { _get, _post, _delete, isApiSuccess } = useService(appConfig.dedicatedSummaryApiUrl);

const pnq_token = getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.KYC_AUTH_TOKEN);

const kyc_token = getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.KYC_AUTH_TOKEN);

const aehKycLoginAsync = (payload) => {
  return _post(COMMON.AEH_LOGIN, payload)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const createOrderAsync = (payload, token) => {
  payload['leadAuthorizationToken'] = token || pnq_token;

  return _post(KYC.CREATE_ORDER, payload)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const fetchOrderAsync = (token) => {
  const config = {
    headers: {
      Authorization: token || kyc_token
    }
  };

  return _get(KYC.FETCH_ORDER, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const updateOrderAsync = (payload = {}, token) => {
  const config = {
    headers: {
      Authorization: token || kyc_token
    }
  };

  return _post(KYC.UPDATE_ORDER, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const submitOrderAsync = (token) => {
  const config = {
    headers: {
      Authorization: token || kyc_token
    }
  };

  return _post(KYC.SUBMIT_ORDER, {}, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const cancelOrderAsync = (payload, token) => {
  const config = {
    headers: {
      Authorization: token || kyc_token
    }
  };

  return _post(KYC.CANCEL_ORDER, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const uploadDocumentsAsync = (payload, onUploadProgress, token, abortController = new AbortController()) => {
  const abortSignal = abortController?.signal;
  const config = {
    headers: {
      Authorization: token || kyc_token
    },
    abortSignal,
    onUploadProgress
  };

  return _post(KYC.UPLOAD_DOC, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const deleteDocumentsAsync = (payload, token) => {
  const config = {
    params: payload,
    headers: {
      Authorization: token || kyc_token
    },
    responseType: 'arraybuffer'
  };

  return _delete(KYC.DELETE_DOC, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const getDocumentsAsync = (payload, token) => {
  const config = {
    params: payload,
    headers: {
      Authorization: token || kyc_token
    },
    responseType: 'arraybuffer'
  };

  return _get(KYC.GET_DOC, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const downloadDocumentsAsync = (fileUrl, token) => {
  const config = {
    headers: {
      Authorization: token || kyc_token
    },
    responseType: 'blob'
  };

  return _get(`${KYC.DOWNLOAD_DOC}${fileUrl}`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const sendOtpAsync = (payload, token) => {
  const config = {
    headers: {
      Authorization: token || kyc_token
    }
  };

  return _post(KYC.SEND_OTP, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const verifyOtpAsync = (payload, token) => {
  const config = {
    headers: {
      Authorization: token || kyc_token
    }
  };

  return _post(KYC.VERIFY_OTP, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

export {
  createOrderAsync,
  fetchOrderAsync,
  uploadDocumentsAsync,
  getDocumentsAsync,
  deleteDocumentsAsync,
  updateOrderAsync,
  submitOrderAsync,
  cancelOrderAsync,
  sendOtpAsync,
  verifyOtpAsync,
  downloadDocumentsAsync,
  aehKycLoginAsync
};
